<template>
  <div class="">
    update
  </div>
</template>

<script>
export default {
  name: "UpdateEvent"
}
</script>


<style scoped>

</style>